export const alinaMatlakiewicz = {
    'mydrId': 'alinamatlakiewicz',
    'firstName': 'Dr n. hum. Alina',
    'lastName': 'Matlakiewicz',
    'profession': 'Psycholog, psychoterapeuta',
    'avatar': 'alina-matlakiewicz.webp',
    'slug': 'psycholog-biznesu-psychoterapeuta-alina-matlakiewicz',
    'locations': ['torun'],
    'services': [
        ['psychoterapy', 'adult'],
        ['psychoterapy', 'parents'],
    ]
}